import React from 'react';
import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';

const APP_VERSION = 'v1.0.0';


const AppVersion = ({ 
  size = 'small', 
  variant = 'inline',
  showLabel = true,
}) => {
  const fontSize = size === 'small' ? '0.70rem' : '0.75rem';
  const fontSizeLabel = size === 'small' ? '0.68rem' : '0.72rem';

  const VersionLink = (
    <Link
      component={RouterLink}
      to="/release-notes"
      underline="hover"
      sx={{
        fontSize,
        fontWeight: 700,
        color: 'primary.main',
        cursor: 'pointer',
        textDecoration: 'none',

        '&:hover': {
          textDecoration: 'underline',
          opacity: 0.9,
        },
      }}
    >
      {APP_VERSION}
    </Link>
  );

  if (variant === 'footer') {
    return (
      <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
        {showLabel && (
          <Typography 
            variant="caption" 
            sx={{ 
              fontSize: fontSizeLabel,
              color: 'text.secondary',
              fontWeight: 500,
            }}
          >
            Version:
          </Typography>
        )}
        {VersionLink}
      </Stack>
    );
  }

  // Default inline variant
  return (
    <Typography 
      variant="caption" 
      sx={{
        fontSize,
        color: 'text.secondary',
        fontWeight: 500,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      {showLabel && <>Version: </>}
      {VersionLink}
      
    </Typography>
  );
};

AppVersion.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['footer', 'inline']),
  showLabel: PropTypes.bool,
};

export default AppVersion;
export { APP_VERSION };